import { action, makeObservable } from "mobx";

// interface SharedStateProperty {
//     [key: any]: any
// }

export class SharedStateStore {

    constructor() {
        makeObservable(this, {
          setState: action
        });
    }
    
    setState(properties: {}, callback: Function | undefined = undefined) {
        Object.keys(properties).forEach(key=> {
            this[key] = properties[key];
        })
        if (callback) callback();
    }

}